import { INewContactInfo } from '../../../../common/models/contact/INewContactInfo';

export const initialFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: ''
};

export const trimValues = ({ email, firstName, lastName, phoneNumber }: INewContactInfo): INewContactInfo => ({
  email: email?.trim(),
  firstName: firstName.trim(),
  lastName: lastName.trim(),
  phoneNumber: phoneNumber?.trim()
});

export const unreachablePhone = {
  id: 'unreachablePhone',
  message: 'This number cannot receive text messages. Please provide a mobile number or use email address instead.'
};
